import React from "react";
import Navbar from "./navbar";
import avatar from "../../assets/images/avatar.png";
import whatsappLogo from "../../assets/images/whatsapp_logo.png";

export default (props) => (
    <nav className="main-header navbar navbar-expand navbar-light navbar-white border-bottom-0" style={{ maxWidth: "100vw" }}>
        <ul className="navbar-nav">
            <li className="nav-item">
                <a id="hamburger-menu" className="nav-link" data-widget="pushmenu" role="button">
                    <i className="fas fa-bars" style={{ color: "#BA0000" }}></i>
                </a>
            </li>
        </ul>
        <Navbar />
        {/* <a
            title="Entrar em contato pelo WhatsApp"
            href="https://wa.me/5555996214926?text=Olá, gostaria de mais informações!"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#FFF" }}
        >
            <img src={avatar} height={30} style={{ marginRight: 10 }} alt="Gradios"></img>
            <img style={{ marginTop: -10, marginLeft:-15 }} src={whatsappLogo} alt="" height={20} />
        </a> */}
    </nav>
);
